import {
    AddTimeStripsBkmAction,
    BookmarkType, DeleteBookmarkAction,
    ErrorBookmarkForPaneAction,
    ExpandBookmarkPaneAction,
    FetchBookmarkForPaneAction,
    GetBookmarksAction,
    InitBookmarkForPaneAction, SetBkmSortingTypeAction,
    SetBookmarksAction,
    SetSelectedItemsAction,
    SetSourceForBookmarkPaneAction,
    StartBookmarkPaneAction,
    SuccessBookmarkForPaneAction,
    TimestripErrorBkmAction,
    TimestripFetchBkmAction,
    SetBookmarkCheckedPaneAction
} from "./types";

import {getStreamType} from "../timeline/types";

export const getBookmarks = (pane?: number) : GetBookmarksAction => ({type: 'getBookmarks', pane});

export const setBookmarks = (bookmarksData: BookmarkType[]) : SetBookmarksAction => ({type: 'setBookmarks', bookmarksData});

export const initBookmarkForPane = (pane: number, url: string, camID: string, camName: string, timeBounds: {start: number, end: number}) : InitBookmarkForPaneAction =>
    ({type: 'initBookmarkForPane', pane, url, camID, camName, timeBounds});

export const fetchBookmarkForPane = (pane: number) : FetchBookmarkForPaneAction => ({type: 'fetchBookmarkForPane', pane});

export const errorBookmarkForPane = (pane: number, camName?: string) : ErrorBookmarkForPaneAction => ({type: 'errorBookmarkForPane', pane, camName});

export const successBookmarkForPane = (pane: number) : SuccessBookmarkForPaneAction => ({type: 'successBookmarkForPane', pane});

export const startBookmarkPane = ({pane, width, height, camId, streamId, timeBounds, url}: getStreamType) : StartBookmarkPaneAction =>
    ({type: 'startBookmarkPane', pane, width, height, camId, streamId, timeBounds, url});

export const setSourceForBookmarkPane = (src: string, pane: number) : SetSourceForBookmarkPaneAction => ({type: 'setSourceForBookmarkPane', src, pane});
///////////////////////

export const timestripIsFetchingBkm = (pane: number) :  TimestripFetchBkmAction=> ({type: 'timestripFetchBkm', pane});

export const timestripErrorBkm = (pane: number) : TimestripErrorBkmAction => ({type: 'timestripErrorBkm', pane});

export const addTimeStripBkm = (pane: number, strips: any[] | null, continuation_id: string | null) : AddTimeStripsBkmAction => ({
    type: 'addTimeStripsBkm',
    pane,
    strips,
    continuation_id
});

/////////////////////////////////////////////////////////

export const expandBookmarkPane = (expanded: number | null) : ExpandBookmarkPaneAction => ({type: 'expandBookmarkPane', expanded});

export const setSelectedItems = (items: number[]) : SetSelectedItemsAction => ({type: 'setSelectedItems', items});

export const setBookmarkCheckedPane = (pane: number, time: number) : SetBookmarkCheckedPaneAction => ({type: 'setBookmarkCheckedPane', pane, time});

export const deleteBookmark = (ids: Array<number | string>, pane?: number) : DeleteBookmarkAction => ({type: 'deleteBookmark', ids, pane});

export const setBkmSortingType = (sorting: {type: string, direction: number}) : SetBkmSortingTypeAction => ({type: 'setBkmSortingType', sorting});